/** @jsxImportSource @emotion/react */
import { ContainerFluidStyle } from "./style.index";

const ContainerFluid = ({ children }: { children: React.ReactNode }) => {
  return <div css={ContainerFluidStyle.self}>{children}</div>;
};
export default ContainerFluid;
